import { Typography } from '@packages/fenrir/components';

type FrameworkOverviewAccordionItemProps = {
  number?: number;
  label: string;
};

export const FrameworkOverviewAccordionItem: React.FC<
  FrameworkOverviewAccordionItemProps
> = ({ label, number }) => {
  return (
    <Typography key={label} color="textSecondary" variant="body2">
      {number ? `${number}. ` : ''}
      {label}
    </Typography>
  );
};
